import type { GridRowId } from "@mui/x-data-grid";
import FormCreateShipment from "../shipments/FormCreateShipment";
import Modal from "./Modal";

export default function ModalCreateShipment({
  ids,
  isOpen,
  onClose,
}: {
  ids?: Set<GridRowId>;
  isOpen: boolean;
  onClose: () => void;
}) {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={`Crear envío con ${ids?.size || 0} paquete(s) seleccionado(s)`}
      content={<FormCreateShipment onClose={onClose} ids={ids} />}
    />
  );
}
